import React from "react";
import Field from "../../Common/Field/Field";
import App from "../../../pages/report/multiSelect";
const StyleDownloads = props => {
    return (
        <div >
            <div class="col-md-12 d-flex justify-content-center text-center mx-auto">
                <div className="col-md-3 px-2" style={{ zIndex: "1000" }}>
                    <label>Customer department</label>
                    <App
                        customerInfo={props.customerWithDepartment}
                        selectedCustomers={props.storeCustomerData}
                    />
                </div>
                <div className="col-md-2" style={{ zIndex: "999" }}>
                    <label>Date From</label>
                    <Field
                        inputType="date"
                        inputName="fromDate"
                        label="from Date"
                        value={props.fromDate}
                        onChange={props.updateState}
                        disabled={false}
                        className="Select-control"
                    />
                </div>
                <div className="col-md-2" style={{ zIndex: "999" }}>
                    <label>Date To</label>
                    <Field
                        inputType="date"
                        inputName="toDate"
                        label="to Date"
                        value={props.toDate}
                        onChange={props.updateState}
                        disabled={false}
                        className="Select-control"
                    />
                </div>
                <div className="col-md-2" style={{ zIndex: "1000" }}>
                    <label>Actioned By</label>
                    <Field
                        inputType="select"
                        inputName="actionedBy"
                        value={props.actionedBy}
                        options={props.actionedByOptions}
                        onChange={props.updateState}
                        disabled={false}
                        className="Select-control"
                    />
                </div>
            </div>
        </div>
    );
};

export default StyleDownloads;


// WEBPACK FOOTER //
// ./src/components/Report/forms/StyleDownloads.js